<dv-dynamic-form
  formTitle="{{
    'VehicleTripSetup.TripDepartmentFormTitle' | translate | uppercase
  }}"
  [elements]="departmentElements | translateElements"
  [formGroup]="formGroup">
</dv-dynamic-form>
<hr class="form-divider" />
<dv-dynamic-form
  class="dynamic-form-background"
  [formTitle]="'VehicleTripSetup.Purpose' | translate | uppercase"
  [elements]="purposeElements | translateElements"
  [formGroup]="formGroup">
</dv-dynamic-form>
<hr class="form-divider" />
<dv-dynamic-form
  formTitle="{{ 'VehicleTripSetup.PrivateTaxable' | translate | uppercase }}"
  [elements]="privateTaxableElements | translateElements"
  [formGroup]="formGroup">
</dv-dynamic-form>
<hr class="form-divider" />
<dv-dynamic-form
  class="dynamic-form-background"
  formTitle="{{ 'VehicleTripSetup.TripPositions' | translate | uppercase }}"
  [elements]="tripPositionElements | translateElements"
  [formGroup]="formGroup">
</dv-dynamic-form>
<hr class="form-divider" />
<dv-dynamic-form
  formTitle="{{ 'VehicleTripSetup.FerryDiscountPlan' | translate | uppercase }}"
  [elements]="ferryDiscountElements | translateElements"
  [formGroup]="formGroup">
</dv-dynamic-form>
<dv-save-panel
  labelCancel=""
  [disableSave]="!formGroup.dirty || !formGroup.valid"
  labelSave="{{ 'General.Save' | translate }}"
  (save)="onSave()">
</dv-save-panel>
